import { CSSProperties } from "react";
import { variantBAssets, variantBProviders } from "../../Utils/variantBAssets";

type ProviderLogo = readonly [string, string];

export interface LanderV2LoadingOverlayProps {
  title: string;
  subtitle: string;
  illustrationSrc?: string;
  illustrationAlt?: string;
  providerLogos?: readonly ProviderLogo[];
  backgroundColor?: string;
}

export function LanderV2LoadingOverlay({
  title,
  subtitle,
  illustrationSrc = variantBAssets.onlineSchoolLoader,
  illustrationAlt = "",
  providerLogos = variantBProviders,
  backgroundColor = "#ffffff",
}: LanderV2LoadingOverlayProps) {
  const style = { "--lv2-loader-bg": backgroundColor } as CSSProperties;
  const repeatedLogos = [...providerLogos, ...providerLogos];
  const hasProviderLogos = providerLogos.length > 0;

  return (
    <div className="pa-v1-loading-overlay" role="status" aria-live="polite" style={style}>
      <section className="pa-v1-loading-modal" aria-label={`${title} ${subtitle}`}>
        <h1>{title}</h1>
        <img className="pa-v1-loading-illustration" src={illustrationSrc} alt={illustrationAlt} aria-hidden={!illustrationAlt} />
        <p className="pa-v1-loading-status">
          <span className="pa-v1-loading-status-copy">
            {subtitle}
            <span className="dot-loader" aria-hidden="true">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </span>
        </p>
        {hasProviderLogos && (
          <div className="pa-v1-loading-logo-window" aria-hidden="true">
            <div className="pa-v1-loading-logo-track">
              {repeatedLogos.map(([name, src], index) => (
                <img key={`${name}-loading-${index}`} src={src} alt="" />
              ))}
            </div>
          </div>
        )}
        <div className="pa-v1-rating">
          <span>Rated <strong>Excellent</strong></span>
          <span className="pa-v1-rating-stars" aria-label="5 star rating">
            <i className="bi bi-star-fill" aria-hidden="true"></i>
            <i className="bi bi-star-fill" aria-hidden="true"></i>
            <i className="bi bi-star-fill" aria-hidden="true"></i>
            <i className="bi bi-star-fill" aria-hidden="true"></i>
            <i className="bi bi-star-fill" aria-hidden="true"></i>
          </span>
        </div>
      </section>
    </div>
  );
}
